<ng-container *ngIf="!embedded">
  <app-nav-bar></app-nav-bar>
  <app-side-bar></app-side-bar>
  <app-settings-modal></app-settings-modal>
</ng-container>

<div class="container">
  <div
    class="container-shop-companies"
    [ngClass]="{ 'embedded-view': embedded }"
  >
    <div class="header">
      <div>
        <h1 class="title">{{ 'SHOP_COMPANIES' | translate }}</h1>
        <p class="description">
          {{ 'SHOP_COMPANIES_DESCRIPTION' | translate }}
        </p>
      </div>
      <button
        class="btn btn-outline-primary primary-btn"
        type="button"
        (click)="createCompany()"
      >
        {{ 'NEW_SHOP_COMPANY' | translate }}
      </button>
    </div>

    <div class="form-card">
      <div class="search-container">
        <input
          type="search"
          [(ngModel)]="searchString"
          [placeholder]="'SEARCH' | translate"
        />
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage | translate }}
      </div>
      <div class="alert alert-warning" *ngIf="deleteMessage">
        {{ deleteMessage | translate }}
      </div>

      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table>
          <thead>
            <tr>
              <th scope="col" class="table-start">Id</th>
              <th scope="col">{{ 'NAME' | translate }}</th>
              <th scope="col">{{ 'LEGAL_NAME' | translate }}</th>
              <th scope="col">{{ 'PHONE' | translate }}</th>
              <th scope="col">{{ 'STATUS' | translate }}</th>
              <th scope="col">{{ 'EDIT' | translate }}</th>
              <th scope="col" class="table-end">{{ 'DELETE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let company of filteredCompanies">
              <td>{{ company.shopCompanyId }}</td>
              <td>{{ company.companyName }}</td>
              <td>{{ company.companyLegalName }}</td>
              <td>{{ company.companyPhone }}</td>
              <td>
                {{ (company.status ? 'ACTIVE' : 'INACTIVE') | translate }}
              </td>
              <td>
                <button
                  class="btn btn-primary primary-btn"
                  type="button"
                  (click)="editCompany(company.shopCompanyId)"
                >
                  {{ 'EDIT' | translate }}
                </button>
              </td>
              <td>
                <button
                  class="btn btn-primary remove-btn"
                  type="button"
                  (click)="modalDelete = true; companyToDelete = company"
                >
                  {{ 'DELETE' | translate }}
                </button>
              </td>
            </tr>
            <tr *ngIf="filteredCompanies.length === 0">
              <td colspan="6">{{ 'NO_SHOP_COMPANIES' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-confirmation-modal
  *ngIf="modalDelete"
  [title]="'CONFIRM_DELETE_SHOP_COMPANY' | translate"
  [message]="'DELETE_SHOP_COMPANY_WARNING' | translate"
  [confirmText]="'DELETE' | translate"
  [cancelText]="'CANCEL' | translate"
  (response)="deleteCompany($event)">
</app-confirmation-modal>

<ng-container *ngIf="!embedded">
  <app-footer></app-footer>
</ng-container>
